// extracted by mini-css-extract-plugin
module.exports = {"sideImage":"ResetForgottenPassword_sideImage__1SCGO","mainContainer":"ResetForgottenPassword_mainContainer__1bqvW","mainColumn":"ResetForgottenPassword_mainColumn__7cy55"};